import React from 'react';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { NoneFoundOverlay } from 'components/ContainerTable';
import { WATCH_LIST_QUERY_PARAMS } from '../../../constants';
import { clearFilters } from '../../controls/filters/utils';

export const NoContainersFoundOverlay: React.FC = () => {
  const { setSearchParams } = useCustomSearchParams(WATCH_LIST_QUERY_PARAMS, true);

  const handleResetFilters = React.useCallback(() => {
    const newSearchParams = clearFilters();
    setSearchParams(newSearchParams);
  }, [setSearchParams]);

  return <NoneFoundOverlay clearFilters={handleResetFilters} variant="containers" />;
};
NoContainersFoundOverlay.displayName = 'TrackAndTrace.ContainerTable.NoContainersFoundOverlay';
